<script setup lang="ts">
/**
 * UI-kit component
 * Category: Other
 * Name: DropZoneArea
 */
import type { DropZoneAreaProps } from '../types/interfaces'

import { faCloudArrowUp } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary } from '@shared/ui/buttons'

import { useDropZoneArea } from '../composables/use-drop-zone-area.hook'

defineOptions({
  name: 'DropZoneArea',
})

const props = withDefaults(defineProps<DropZoneAreaProps>(), {
  disabled: false,
  title: 'Drag & Drop your files here',
  browseText: 'Browse files',
  accept: undefined,
  multiple: true,
})

const emit = defineEmits<{
  files: [files: File[]]
}>()

const {
  areaRef,
  rootClasses,
  triggerBrowse,
} = useDropZoneArea({
  props,
  onFiles: files => emit('files', files),
})
</script>

<template>
  <div
    ref="areaRef"
    :class="rootClasses"
    @click="triggerBrowse"
  >
    <div class="drop-zone-area__icon">
      <AppIcon
        :icon="faCloudArrowUp"
        size="big"
        color="slate-900"
      />
    </div>
    <AppText
      name="body1"
      color="slate-900"
    >
      {{ title }}
    </AppText>
    <AppText
      name="body2"
      class="drop-zone-area__divider"
    >
      - or -
    </AppText>
    <BtnPrimary
      :text="browseText"
      color="blue"
      :disabled="disabled"
    />
  </div>
</template>

<style lang="scss" scoped src="../styles/_drop-zone-area.scss" />
